import Card from "@/atoms/Card";
import SubLayout from "@/containers/layout/LandingLayout/SubLayout";
import Image from "next/image";
import { useWindowSize } from "@/shared/hooks/useWindowSize";
import Screen from "@/constants/screens";
import NoDeposit from "@/public/landing/companyFeatures/no-deposit.svg?url";
import Rent from "@/public/landing/companyFeatures/rent.svg?url";
import HorizontalBar from "@/atoms/HorizontalBar";
import VerticalBar from "@/atoms/VerticalBar";
import LockedInPrice from "@/public/landing/companyFeatures/locked-in-price.svg?url";
import Tada from "@/public/landing/companyFeatures/tada.svg?url";
import Champion from "@/public/landing/companyFeatures/champion.svg?url";
import Eligibility from "@/public/landing/companyFeatures/eligibility.svg?url";
const BenefitsOfKeyzyNow = (props: { hideDivider?: boolean }): JSX.Element => {
  const { width } = useWindowSize();
  const { hideDivider = false } = props;
  return (
    <SubLayout allowOverflow className="bg-white">
      {!hideDivider && (
        <section className="px-4 mt-20 bg-white overflow-hidden md:mx-6 lg:px-0 h-6 relative">
          <Image
            src={`/landing/${
              width < Screen.Tablet_768 ? "mobile-doodle.svg" : "tablet-doodle.svg"
            }`}
            alt="doodle"
            layout="fill"
            objectFit="contain"
          />
        </section>
      )}
      <section className="relative w-full pt-16 md:pb-0">
        <div id="why" className="absolute top-0" />
        <h2 className="text-4xl font-bold text-center xl:text-5xl text-landing-blue mb-11 xl:mb-14">
          Benefits of Keyzy
        </h2>

        <div className="md:h-64 md:flex md:justify-center md:flex-row mb-0 text-center">
          <Card
            title="Fixed rent for 2 or 3 years"
            subtitle=""
            size="big"
            image={NoDeposit}
            titleWrap={false}
          />

          <HorizontalBar className="inline-block my-4 md:hidden" />
          <VerticalBar className="hidden md:inline-block md:mx-7 xl:mx-20" />

          <Card
            title="Your rent becomes your deposit"
            subtitle=""
            size="big"
            image={Rent}
            titleWrap={false}
          />
          <HorizontalBar className="inline-block my-4 md:hidden" />
          <VerticalBar className="hidden md:inline-block md:mx-7 xl:mx-20 " />

          <Card
            title="Buy later at a locked-in price"
            subtitle=""
            size="big"
            image={LockedInPrice}
            titleWrap={false}
          />
        </div>

        <HorizontalBar className="hidden md:inline-block my-4 md:my-11 xl:my-14" />

        <div className="md:h-64 md:flex md:justify-center md:flex-row mb-8">
          <HorizontalBar className="inline-block md:hidden my-4 md:my-11 xl:my-14" />

          <Card
            title="Flexible Eligibility Criteria"
            subtitle=""
            size="big"
            image={Eligibility}
            titleWrap={false}
          />

          <HorizontalBar className="inline-block my-4 md:hidden" />
          <VerticalBar className="hidden md:inline-block md:mx-7 xl:mx-20" />

          <Card
            title="Better than a traditional mortgage"
            subtitle=""
            size="big"
            image={Champion}
            titleWrap={false}
          />
          <HorizontalBar className="inline-block my-4 md:hidden" />
          <VerticalBar className="hidden md:inline-block md:mx-7 xl:mx-20 " />

          <Card
            title="Easily Move From Renting to Owning"
            subtitle=""
            size="big"
            image={Tada}
            titleWrap={false}
          />
          <HorizontalBar className="inline-block my-4 md:hidden" />
        </div>
      </section>
    </SubLayout>
  );
};

export default BenefitsOfKeyzyNow;
